import { Select, SelectProps } from '@mantine/core';
import { CompressionAndExport } from '@/app/workflows/actions/interfaces';

type FileType = CompressionAndExport['fileExports'][number]['fileType'];
const options: { label: FileType; value: FileType }[] = [
  { label: 'glb', value: 'glb' },
  { label: 'gltf', value: 'gltf' },
  { label: 'usd', value: 'usd' },
  { label: 'usdz', value: 'usdz' },
  { label: 'obj', value: 'obj' },
  { label: 'stl', value: 'stl' },
  { label: 'ply', value: 'ply' },
  { label: 'ctm', value: 'ctm' },
  { label: 'fbx', value: 'fbx' },
  { label: 'vrm', value: 'vrm' },
];

export function FileFormatSelect(props: SelectProps) {
  return <Select label='File format' styles={{ label: { fontWeight: 600 } }} data={options} {...props} />;
}
